import fullFunctionalityConfig from './fullFunctionalityConfig'

export default {
    ...fullFunctionalityConfig,
    continuousSave: false,
    initialSeed: 1000,
    minNumOfPagesToCalculateRenderHints: 0
}
